import { createStore } from 'vuex'
import userActions from './actions/userActions'
import stationActions from './actions/stationActions'
import dataActions from './actions/dataActions'
import roundDecimals from '../utils/roundDecimals'
import getRolList from '../utils/getRolList'
import dictionary from '../services/variablesDictionary'
import filterStations from '../utils/filterStations'

export default createStore({
        state: {
                status: '',
                token: localStorage.getItem('access_token') || '',
                user: {},
                sidebar: false,
                airQualityStations: [],
                HydroclimatologicalStations: [],
                groundWaterStations: [],
                availableVariables:[],
                seeButton: false,
                station_id_selected: "",
                variablesSelected: [],
                initDate: "",
                endDate: "",
                minDate: "",
                maxDate: "",
                errorRange: false,
                station_name: '',
                typology: '',
                labels_variables: [],
                availableParticulateMaterial: [],
                mode: '',
                index: Number,
                totalPages: 0,
                data: [],
                tableHeader: [],
                page: 1,
                perPage: 10,
                dataQuantity: Number,
                loadingScreen: false,
                noDataScreen: false,
                rememberToken: '',
                errorPassword: false,
                errorDeleteUser: false,
                seeToast: false,
                emailUserList:[],
                userList: {},
                roleList: [],
                errorCreateUser: false,
                userAction: '',
                isGases: false,
                dictionaryVariables: {
                        airQuality: {
                                ...dictionary.airGasesVariables,
                                ...dictionary.airParticulateMaterialVariables
                        },
                        hydrometeorological: dictionary.hydrometeorological,
                        hydrological: dictionary.hydrological,
                        groundWater: dictionary.groundWater
                }
                },
        mutations: {
                auth_request(state) {
                        state.status = 'loading'
                },
                auth_success(state, token, user) {
                        state.status = 'success'
                        state.token = token
                        state.user = user
                },
                auth_error(state) {
                        state.status = 'error'
                },
                logout(state) {
                        state.status = ''
                        state.token = ''
                },
                start_sidebar(state) {
                        state.sidebar = true
                },
                close_sidebar(state) {
                        state.sidebar = false
                },
                add_hydro_station(state,stations){
                        state.HydroclimatologicalStations = filterStations(stations);
                },
                add_air_station(state,station){
                        state.airQualityStations.push(station)
                },
                add_water_station(state,station){
                        state.groundWaterStations.push(station)
                },
                activate_error_range(state){
                        state.errorRange = !state.errorRange
                },
                activate_error_password(state){
                        state.errorPassword = !state.errorPassword
                },
                activate_error_delete_user(state){
                        state.errorDeleteUser = !state.errorDeleteUser
                },
                activate_error_user_create(state){
                        state.errorCreateUser = !state.errorCreateUser
                },
                activate_toast(state){
                        state.seeToast = !state.seeToast
                },
                check_form (state, action) {
                        state.seeButton = action
                },
                change_initial_year (state, initDate) {
                        state.initDate = initDate
                },
                change_end_year (state, endDate) {
                        state.endDate = endDate
                },
                change_id (state, newId) {
                        state.station_id_selected = newId
                },
                change_name_station (state, newName) {
                        state.station_name = newName
                },
                get_dates (state, newDates){
                        state.minDate = newDates.min.fecha
                        state.maxDate = newDates.max.fecha
                },
                get_available_variables(state, newVariables) {
                        let variablesToUse = [];
                        let labelsToUse = [];
                        let particulateMaterialVariables = [];

                        switch (state.typology) {
                          case 'hydrometeorological':
                            variablesToUse = Object.entries(newVariables).filter(([code]) => code in dictionary[state.typology]).map(([code]) => code);
                            labelsToUse = variablesToUse.map(code => dictionary[state.typology][code]);
                            break;

                           case 'hydrological':
                             variablesToUse = Object.entries(newVariables).filter(([code]) => code in dictionary[state.typology]).map(([code]) => code);
                             labelsToUse = variablesToUse.map(code => dictionary[state.typology][code]);
                             break;

                           case 'groundWater':
                             variablesToUse = Object.entries(newVariables).filter(([code]) => code in dictionary[state.typology]).map(([code]) => code);
                             labelsToUse = variablesToUse.map(code => dictionary[state.typology][code]);
                             break;

                           case 'airQuality':
                             variablesToUse = Object.entries(newVariables).filter(([code]) => code in state.dictionaryVariables[state.typology]).map(([code]) => code);
                             particulateMaterialVariables = Object.entries(newVariables).filter(([code]) => code in dictionary.airParticulateMaterialVariables).map(([code]) => code);
                             break;
                        }
                        state.availableVariables = variablesToUse;
                        state.labels_variables = labelsToUse;
                        state.availableParticulateMaterial = particulateMaterialVariables;

                },
                change_variables (state, newVariables) {
                        if (newVariables == 'particularMaterialManual' || newVariables == 'particularMaterialAutomatic') {
                                state.variablesSelected = state.availableParticulateMaterial
                        } else {
                                state.variablesSelected = newVariables
                        }
                },
                clear_options (state) {
                        state.availableVariables= [],
                        state.seeButton = false
                        state.station_id_selected= ""
                        state.variablesSelected= [],
                        state.initDate= "",
                        state.endDate= "",
                        state.minDate= "",
                        state.maxDate= "",
                        state.station_name= '',
                        state.typology= '',
                        state.labels_variables= [],
                        state.availableParticulateMaterial= [],
                        state.mode= '',
                        state.totalPages = 0,
                        state.page= 1,
                        state.perPage= 10,
                        state.dataQuantity= Number,
                        state.loadingScreen= false,
                        state.noDataScreen= false,
                        state.tableHeader= [],
                        state.isGases= false
                },
                change_typology (state, newTypology){
                        state.typology = newTypology
                },
                change_mode (state, newMode){
                        state.mode = newMode
                },
                change_index_pdf (state, i) {
                        state.index = i
                },
                change_totalPages (state, newTotal) {
                        state.totalPages = newTotal
                },
                change_data (state, newData){
                        state.data = roundDecimals(newData, state.mode)
                },
                change_tableHeader(state) {
                        state.tableHeader = []

                        if (state.mode === 'automatic') {
                                state.tableHeader.push('Fecha (AAAA-MM-DD)')
                                state.tableHeader.push('Tiempo (HH:MM:SS)')
                        } else {
                                state.tableHeader.push('Fecha (AAAA-MM-DD)')
                        }
                        state.variablesSelected.forEach((key) => {
                                if (key in state.dictionaryVariables[state.typology]) {
                                  state.tableHeader.push(state.dictionaryVariables[state.typology][key]);
                                }
                        });
                },
                change_page(state, newPage) {
                        state.page = newPage
                },
                change_dataQuantity(state, newTotal){
                        state.dataQuantity = newTotal
                        if(state.dataQuantity === 0){
                                state.noDataScreen = !state.noDataScreen
                        }
                },
                change_state_loading (state) {
                        state.loadingScreen = !state.loadingScreen
                },
                change_perPage (state, newPerPage) {
                        state.perPage = newPerPage
                },
                change_remember_token (state, newRememberToken) {
                        state.rememberToken = newRememberToken
                },
                get_users(state, newUserList){
                        state.userList= {}
                        newUserList.forEach(user => {
                                state.userList[user.id] = user;
                        })
                },
                add_role_list(state, newList){
                        state.roleList = getRolList(newList)
                },
                change_user_action(state, newAction) {
                        state.userAction = newAction
                },
                change_mode_variables_air(state){
                        let gasesVariables = Object.keys(dictionary.airGasesVariables)
                        state.isGases = gasesVariables.some(variable => state.availableVariables.includes(variable));
                }
        },
        actions: {
                ...userActions,
                ...stationActions,
                ...dataActions,

                Activate_Error_Range({ commit }){
                        commit('activate_error_range')
                },
                Check_Form ({ state, commit }) {
                        if (state.station_name && state.initDate && state.endDate) {
                          if (state.variablesSelected.length > 0) {
                            commit('check_form', true)
                          } else commit('check_form', false)
                        }
                },
                Change_Initial_Year ({ commit }, initDate) {
                        commit('change_initial_year', initDate)
                },
                Change_End_Year ({ commit }, endDate) {
                        commit('change_end_year', endDate)
                },
                Change_Id ({ commit }, newId) {
                        commit('change_id', newId)
                },
                Change_Name_Station ({ commit }, newName) {
                        commit('change_name_station', newName)
                },
                Change_Variables ({ commit }, newVariables) {
                        commit('change_variables', newVariables)
                },
                Change_Typology ({ commit }, newTypology) {
                        commit('change_typology', newTypology)
                },
                Change_Mode ({ commit }, newMode){
                        commit('change_mode', newMode)
                },
                Change_Index ({ commit }, i) {
                        commit('change_index_pdf', i)
                },
                Change_tableHeader ({ commit }, newVariablesHead) {
                        commit('change_tableHeader', newVariablesHead)
                },
                Change_page({ commit }, newPage) {
                        commit('change_page', newPage)
                },
                Change_perPage({ commit }, newPerPage) {
                        commit('change_perPage', newPerPage )
                },
                Change_save_buttom({ commit }, isMatchPassword, isValidPassword){
                        if (isMatchPassword === true && !isValidPassword) {
                                commit('check_form', true)
                        } else commit('check_form', false)
                },
                Change_save_create_user({ commit }, { isMatchPassword, isPasswordValid, isCompleteForm }) {
                        if (isMatchPassword && isPasswordValid && isCompleteForm) {
                          commit('check_form', true)
                        } else {
                          commit('check_form', false)
                        }
                },
                Activate_Error_Password({ commit }){
                        commit('activate_error_password')
                },
                Activate_Error_Delete_User({ commit }){
                        commit('activate_error_delete_user')
                },
                Activate_Error_Create_User({ commit }){
                        commit('activate_error_user_create')
                },
        },
        getters: {
                isLoggedIn: state => state.token,
                authStatus: state => state.status,
                sidebarStatus: state => state.sidebar
        },
})
